// https://www.sortedtrips.in/admin/api/updateProfile


// import axios from "./axiosInstance";

// const UpdateProfileAPI = {
//     postProfileUpdate: (userId) => axios.post(`/updateProfile`, { user_id: userId, }),
// };

// export default UpdateProfileAPI;


import axios from "./axiosInstance";

const UpdateProfileAPI = {
  postProfileUpdate: (formData) => axios.post(`/updateProfile`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
};

export default UpdateProfileAPI;

